import { useMemo } from "react";

/**
 * Minimal SVG sparkline. Pass `data` as array of numbers (older → newer).
 * Renders both a line and a faint area fill, plus an endpoint marker.
 */
export default function Sparkline({
  data,
  width = 200,
  height = 60,
  stroke = "currentColor",
  fill = "currentColor",
  fillOpacity = 0.12,
  strokeWidth = 1.5,
  showDot = true,
  className = "",
}) {
  const path = useMemo(() => {
    if (!data || data.length < 2) return { line: "", area: "", lastX: 0, lastY: 0 };
    const min = Math.min(...data);
    const max = Math.max(...data);
    const range = max - min || 1;
    const stepX = width / (data.length - 1);
    const points = data.map((d, i) => {
      const x = i * stepX;
      const y = height - ((d - min) / range) * (height - 4) - 2;
      return [x, y];
    });
    const line = points.map(([x, y], i) => `${i === 0 ? "M" : "L"} ${x.toFixed(2)} ${y.toFixed(2)}`).join(" ");
    const area = `${line} L ${width} ${height} L 0 ${height} Z`;
    const [lx, ly] = points[points.length - 1];
    return { line, area, lastX: lx, lastY: ly };
  }, [data, width, height]);

  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} className={className} preserveAspectRatio="none">
      <path d={path.area} fill={fill} fillOpacity={fillOpacity} />
      <path d={path.line} stroke={stroke} strokeWidth={strokeWidth} fill="none" strokeLinecap="round" strokeLinejoin="round" />
      {showDot && (
        <>
          <circle cx={path.lastX} cy={path.lastY} r="5" fill={stroke} opacity="0.3" />
          <circle cx={path.lastX} cy={path.lastY} r="2.5" fill={stroke} />
        </>
      )}
    </svg>
  );
}
